import "./sentry";

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ThemeProvider } from "@mui/material/styles";
import { playerDexTheme } from "./theme/theme";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

/**
 * Dynamically set favicon based on environments
 */
const setFavicon = (file) => {
  // Remove any existing icons
  document.querySelectorAll("link[rel='icon']").forEach((n) => n.remove());

  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, ""); // respects homepage in package.json
  const href = `${base}/${file}?v=${Date.now()}`; // add cache-buster

  const link = document.createElement("link");
  link.rel = "icon";
  link.type = "image/png";
  link.href = href;
  document.head.appendChild(link);
};

// Prefer your custom env if present, else fall back to NODE_ENV
const env = process.env.REACT_APP_NODE_ENV;

const favByEnv = {
  development: "favicon_dev.png", // if you keep REACT_APP_NODE_ENV=development
  production: "favicon.png",
};

setFavicon(favByEnv[env] || favByEnv.production);

// --- React render ---
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={playerDexTheme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
